<template>
  <listTemplate :class="'height__100vh'">
    <template #header>
      <headerTemplate>
        <template #filterByStatus>
          <div class="leftSection">
            <div
              class="header-title wrapper-content__main font-size__large font-weight__bold"
            >
              Quản lý sổ văn bản đến ({{ amountOfDoc }})
            </div>
          </div>
        </template>
      </headerTemplate>
    </template>

    <template #view>
      <div class="view">
        <list-template :classCustom="'list-docs wrapper-content__main soVBan'">
          <template #subHeader>
            <subHeader>
              <template #content>
                <div class="leftSection">
                  <div class="fix-width__large">
                    <el-select
                      class="style-fullWidth"
                      style="background-color: #f8f9fd"
                      v-model="advanceSearchForm.bookId"
                      placeholder="-"
                      size="medium"
                      default-first-option
                      @change="bookChange"
                    >
                      <el-option
                        v-for="item in books"
                        :key="item.id"
                        :label="item.bookName"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <searchTemplate
                  :keyword="keyword"
                  @simpleSearch="simpleSearch"
                  @search="isOpenAdvanceSearchDialog = true"
                >
                  <template #quickFilter>
                    <div
                      class="flex-row flex-left__top fix-width__large margin-right-10 custom-label__input"
                    >
                      <span class="label-input width__auto">Ngày văn bản: </span>
                      <el-date-picker
                        v-model="docDateRange"
                        type="daterange"
                        format="dd/MM/yyyy"
                        class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"
                        :picker-options="dateQuickFilterOption"
                        range-separator="_"
                        start-placeholder="_"
                        end-placeholder="_"
                        align="right"
                        @change="docDateRangeChanged"
                      ></el-date-picker>
                    </div>
<!--                    <div-->
<!--                      class="flex-row flex-left__top fix-width__large margin-right-10 custom-label__input"-->
<!--                    >-->
<!--                      <span class="label-input width__auto">Ngày đến: </span>-->
<!--                      <el-date-picker-->
<!--                        v-model="incomingDateRange"-->
<!--                        type="daterange"-->
<!--                        size="medium"-->
<!--                        format="dd/MM/yyyy"-->
<!--                        class="style-fullWidth bg input-border__bottom input-border__radius__0 bg__transparent"-->
<!--                        :picker-options="dateQuickFilterOption"-->
<!--                        range-separator="_"-->
<!--                        start-placeholder="_"-->
<!--                        end-placeholder="_"-->
<!--                        align="center"-->
<!--                        @change="incomingDateRangeChanged"-->
<!--                      >-->
<!--                      </el-date-picker>-->
<!--                    </div>-->

                    <div class="flex-row flex-left__top margin-right-10 custom-label__input fix-width__large">
                      <span class="label-input width__auto"
                      >Ngày đến:
                      </span>
                      <span class="label-input width__auto">Từ ngày:</span>
                      <el-date-picker
                        v-model="fromIncomingDate"
                        type="date"
                        format="dd/MM/yyyy"
                        class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"
                        placeholder="Chọn ngày bắt đầu"
                        align="right"
                        :clearable="false"
                        @change="filterByIncomingDateRange"
                      ></el-date-picker>
                    </div>

                    <div class="flex-row flex-left__top margin-right-10 custom-label__input fix-width__large">
                      <span class="label-input width__auto">Đến ngày:</span>
                      <el-date-picker
                        v-model="toIncomingDate"
                        type="date"
                        format="dd/MM/yyyy"
                        class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"
                        placeholder="Chọn ngày kết thúc"
                        align="right"
                        :clearable="false"
                        @change="filterByIncomingDateRange"
                      ></el-date-picker>
                    </div>

                  </template>
                  <template #advance>
                    <vbdendavaoso-ld-advance-search-dialog
                      :isOpen="isOpenAdvanceSearchDialog"
                      :form="advanceSearchForm"
                      v-if="isEnableAdvanceSearchDialog"
                      @dialogClosed="isEnableAdvanceSearchDialog = false"
                      @closeDialog="isOpenAdvanceSearchDialog = false"
                      @doSearch="advanceSearch"
                    />
                  </template>
                </searchTemplate>
              </template>
            </subHeader>
          </template>

          <template #body>
            <div class="list">
              <!-- header-title -->
              <div class="header-title flex-row flex__between margin-bottom-10">
                <div class="leftSection flex-row flex__left">
                  <div class="theTitle theTitle__lv5">
                    <span class="stt margin-left-10">STT</span>
                  </div>
                  <div
                    class="theTitle theTitle__lv1 flex-row flex__left clickable"
                    @click="doSort('quote')"
                  >
                    Trích yếu
                    <sort-caret :order="order" :sort="sort" :field="'quote'"/>
                  </div>
                </div>
                <div class="rightSection flex-row flex__right">
                  <!--                  <div-->
                  <!--                    class="theTitle theTitle__lv2 flex-row flex__left padding-left-10 clickable"-->
                  <!--                    @click="doSort('forwardDeptName')"-->
                  <!--                  >-->
                  <!--                    Nơi gửi-->
                  <!--                    <sort-caret-->
                  <!--                      :order="order"-->
                  <!--                      :sort="sort"-->
                  <!--                      :field="'forwardDeptName'"-->
                  <!--                    />-->
                  <!--                  </div>-->
                  <div
                    class="theTitle theTitle__lv2 flex-row flex__left padding-left-10 clickable"
                    @click="doSort('publisherName')"
                  >
                    Đơn vị phát hành
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'publisherName'"
                    />
                  </div>
                  <div
                    class="theTitle theTitle__lv3 flex-row flex__right padding-right-10 clickable"
                    @click="doSort('docDate')"
                  >
                    Ngày văn bản
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'docDate'"
                    />
                  </div>
                  <div
                    class="theTitle theTitle__lv3 flex-row flex__right padding-right-10 clickable"
                    @click="doSort('vbDocInBookUpdateTime')"
                  >
                    Ngày vào sổ
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'vbDocInBookUpdateTime'"
                    />
                  </div>
                  <div
                    class="theTitle theTitle__lv3 flex-row flex__right padding-right-10 clickable"
                    @click="doSort('vbDocInBookBookName')"
                  >
                    Sổ văn bản - Số
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'vbDocInBookBookName'"
                    />
                  </div>
                </div>
              </div>
              <!-- list-docs -->
              <VuePerfectScrollbar
                class="scroll-area"
                :settings="perfectScrollbarSetting"
                infinite-wrapper
              >
                <div class="list-docs">
                  <div
                    v-for="(item, $itemIndex) in incomingDocs"
                    v-bind:key="$itemIndex"
                    class="item flex-row flex__between"
                    @click="viewDetail(item)"
                  >
                    <div class="leftSection flex-row flex__left">
                      <div class="theTitle__lv5">
                        <div class="flex-row flex__left">
                          <div class="section-check">
                            <span class="stt flex-row flex__center">{{
                              $itemIndex + 1
                            }}</span>
                          </div>
                          <img
                            class="icon-small clickable"
                            src="../../assets/img/symbol/file.svg"
                            alt=""
                            @click.stop="
                              downloadAttachment(
                                item,
                                ATTACHMENT_OBJECT_TYPE.VB_DEN
                              )
                            "
                          />
                        </div>
                      </div>
                      <div class="theTitle__lv1 margin-right-10">
                        <div class="title-docs flex-col flex__left">
                          <div
                            class="tt_1 clickable"
                            v-bind:class="textBold(item)"
                          >
                            {{ item.quote }}
                          </div>
                          <div class="tt_2 flex-row flex__left margin-top-10">
                            <span v-if="item.docCode"
                            >{{ item.docCode }}&nbsp;&nbsp;</span
                            >
                            <el-tag
                              v-if="item.docTypeName"
                              size="mini"
                              :class="['priority', 'lv3']"
                            >{{ item.docTypeName }}
                            </el-tag>
                            <el-tag
                              v-if="isShowPriority(item.priorityId)"
                              size="mini"
                              :class="[
                                'priority',
                                getPiorityClass(item.priorityId)
                              ]"
                            >
                              <img
                                src="@/assets/img/new-symbol/zap.svg"
                                alt=""
                                class="icon-very__small"
                              />
                              <span>
                                {{ item.priorityName }}
                              </span>
                            </el-tag>
                            <span>
                               <el-tooltip
                                 content="Văn bản điện tử"
                                 placement="top"
                                 effect="dark"
                                 v-if="isVbDienTu(item)"
                               >
                                 <div class="eIcon">e</div>
                               </el-tooltip>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="rightSection flex-row flex__right">
                      <div
                        class="theTitle__lv2 flex-row flex__left padding-left-10 font-size__small"
                      >
                        <div class="flex-row flex__right txt-left">
                          {{
                            (item.publisherNameDetail ? item.publisherNameDetail + " " : "") +
                            (item.forwardDeptName || item.publisherName  || item.insidePublisherName || item.outsidePublisherName) ||
                            "-"
                          }}
                        </div>
                      </div>

                      <div
                        class="theTitle__lv3 flex-row flex__right padding-right-10 font-size__small"
                      >
                        <div class="flex-row flex__right txt-right">
                          {{
                          item.docDate
                          | dateFormatter({
                          nullValue: "-",
                          dateFormat: "DD/MM/YYYY"
                          })
                          }}
                        </div>
                      </div>
                      <div
                        class="theTitle__lv3 flex-row flex__right padding-right-10 font-size__small"
                      >
                        <div class="flex-row flex__right txt-right">
                          {{
                          item.vbDocInBookUpdateTime
                          | dateFormatter({
                          nullValue: "-",
                          dateFormat: "DD/MM/YYYY"
                          })
                          }}
                        </div>
                      </div>

                      <div
                        class="theTitle__lv3 flex-row flex__right padding-right-10 font-size__small"
                      >
                        <div class="flex-row flex__right txt-left">
                          {{ item.vbDocInBookBookName }} - {{ item.bookNumber }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <infinite-loading v-if="hasInitIncomingDate"
                    ref="infiniteLoading"
                    spinner="spiral"
                    @infinite="infiniteHandler"
                  >
                    <div slot="no-more"></div>
                    <div slot="no-results">Không có dữ liệu</div>
                  </infinite-loading>
                </div>
              </VuePerfectScrollbar>
            </div>
          </template>
        </list-template>
      </div>
    </template>
  </listTemplate>
</template>
<script>
  import InfiniteLoading from "vue-infinite-loading";
  import vbIncomingDocInBookViewService from "../../services/vbIncomingDocInBookViewService";
  import dateFormatter from "../../filters/dateFormatter";
  import constants from "../../constants";
  import utils from "../../services/utils";
  import listTemplate from "../common/list";
  import headerTemplate from "../../components/header/main-header.vue";
  import searchTemplate from "../common/search";
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  import vbAttachmentTokenMixin from "../../mixins/vbAttachmentTokenMixin";
  import {EventBus} from "../../event-bus.js";
  import bookService from "../../services/bookService";
  import VbdendavaosoLdAdvanceSearchDialog from "./components/vbdendavaoso-ld-advance-search-dialog";
  import h from "../../services/h";
  import dateUtils from "../../dateUtils";
  import vbUtils from "../../services/doc/vbUtils";


  export default {
    name: "vb-den-da-vao-so-for-ld-index",
    mixins: [vbAttachmentTokenMixin],
    components: {
      VbdendavaosoLdAdvanceSearchDialog,
      InfiniteLoading,
      listTemplate,
      headerTemplate,
      searchTemplate,
      VuePerfectScrollbar,
      subHeader: () => import("../../components/main/sub-header.vue"),
      createDialog: () => import("./components/CreateDialog.vue"),
      SortCaret: () => import("../doc-out/SortCaret")
    },

    filters: {dateFormatter},

    data() {
      return {
        sortList:[],
        ATTACHMENT_OBJECT_TYPE: constants.ATTACHMENT_OBJECT_TYPE,
        dateQuickFilterOption: utils.getDefaultDateQuickFilterOption(),

        isOpenAdvanceSearchDialog: false,
        isEnableAdvanceSearchDialog: false,
        isOpenDialogCreate: false,
        isEnableDialogCreate: false,
        perfectScrollbarSetting: {maxScrollbarLength: 350},

        incomingDocs: [],
        incomingDocsCount: null,

        selectedDocId: null,

        page: 0,
        size: 10,
        advanceSearchForm: {},
        sort: null,
        order: null,
        keyword: null,
        books: null,
        docDateRange: null,
        incomingDateRange: null,
        fromIncomingDate: null,
        toIncomingDate: null,
        amountOfDoc: 0,
        hasInitIncomingDate: false
      };
    },

    computed: {
      userDeptRoleId() {
        return this.$route.params.userDeptRoleId;
      },
      parentRoute() {
        return this.$route.path.split("/")[3];
      },

      isUserOfDang() {
        const deptPath = this.$store.getters.userDeptRole.deptPath;
        return deptPath.includes('/TCT/DU', 0);
      }
    },

    watch: {
      isOpenDialogCreate(newValue) {
        newValue && (this.isEnableDialogCreate = newValue);
      },
      isOpenAdvanceSearchDialog(newValue) {
        newValue && (this.isEnableAdvanceSearchDialog = newValue);
      },
      isEnableDialogCreate(newValue) {
        if (!newValue) {
          this.selectedDocId = null;
          this.copyFromDocId = null;
        }
      }
    },

    async created() {
      this.setDefaultDocDateRange();
      this.filterByIncomingDateRange();
      this.initQuery();
      await this.loadBooks();
      this.initDocDateRange();
      this.initIncomingDateRange();
      await this.count();
      this.hasInitIncomingDate = true;
    },

    mounted() {
      EventBus.$on(this.parentRoute, () => {
        this.doSearch();
      });
    },

    methods: {
      initDocDateRange() {
        if (this.advanceSearchForm.fromDocDate || this.advanceSearchForm.toDocDate) {
          this.docDateRange = [
            dateUtils.toMoment(this.advanceSearchForm.fromDocDate),
            dateUtils.toMoment(this.advanceSearchForm.toDocDate)
          ];
        } else {
          this.docDateRange = null;
        }
      },

      docDateRangeChanged() {
        this.advanceSearchForm.fromDocDate =
          this.docDateRange && this.docDateRange[0]
            ? this.docDateRange[0].getTime()
            : undefined;
        this.advanceSearchForm.toDocDate =
          this.docDateRange && this.docDateRange[1]
            ? this.docDateRange[1].getTime()
            : undefined;
        this.doSearch();
      },

      setDefaultDocDateRange() {
        const startDate = new Date(new Date().getFullYear(), 0, 1);
        this.fromIncomingDate = startDate;
      },

      filterByIncomingDateRange(event) {
        const a = this.isValidDate(this.fromIncomingDate);
        const b = this.isValidDate(this.toIncomingDate);

        if ((this.fromIncomingDate === null || !a) && (this.toIncomingDate === null || b)) {
          this.fromIncomingDate = new Date(new Date().getFullYear(), 0, 1);
        } else if ((this.toIncomingDate === null || !b) && (this.fromIncomingDate === null || a)) {
          this.toIncomingDate = new Date(new Date().getFullYear(), 11, 31);
        } else if (this.fromIncomingDate > this.toIncomingDate) {
          this.fromIncomingDate = new Date(new Date().getFullYear(), 0, 1);
          this.toIncomingDate = new Date(new Date().getFullYear(), 11, 31);
        }

        this.advanceSearchForm.fromIncomingDate = this.fromIncomingDate ? this.fromIncomingDate.getTime() : undefined;
        this.advanceSearchForm.toIncomingDate = this.toIncomingDate ? this.toIncomingDate.getTime() : undefined;
        this.doSearch();
      },

      isValidDate(date) {
        return date instanceof Date && !isNaN(date);
      },

      initIncomingDateRange() {
        let date = dateUtils.getDatesByQuickFilter(constants.DATE_QUICK_FILTER.CODE.LAST_YEAR)
        this.advanceSearchForm.fromIncomingDate = date[0]*1
        this.advanceSearchForm.toIncomingDate = date[1]*1

        if (this.advanceSearchForm.fromIncomingDate || this.advanceSearchForm.toIncomingDate) {
          this.incomingDateRange = [
            dateUtils.toMoment(this.advanceSearchForm.fromIncomingDate),
            dateUtils.toMoment(this.advanceSearchForm.toIncomingDate)
          ];
        } else {
          this.incomingDateRange = null;
        }
      },

      incomingDateRangeChanged() {
        this.advanceSearchForm.fromIncomingDate =
          this.incomingDateRange && this.incomingDateRange[0]
            ? this.incomingDateRange[0].getTime()
            : undefined;
        this.advanceSearchForm.toIncomingDate =
          this.incomingDateRange && this.incomingDateRange[1]
            ? this.incomingDateRange[1].getTime()
            : undefined;
        console.log(this.advanceSearchForm.fromIncomingDate, this.advanceSearchForm.toIncomingDate)
        this.doSearch();
      },

      isVbDienTu(item){
        if(item.eFlag&&item.eFlag==='1'){
          return true;
        }else {
          return false;
        }
      },

      loadBooks() {
        return bookService
          .findAllForDsvb(constants.BOOK_TYPE.VB_DEN)
          .then(response => {
            this.books = response.data;
            if(this.books) {
              this.books.unshift({id: undefined, bookName: "Tất cả"})
            }
          });
      },

      bookChange() {
        this.doSearch();
      },

      textBold(event) {
        if (event.hasOwnProperty("isRead")) {
          if (event.isRead == "seen") return "";
          else return "text-bold";
        } else return "";
      },

      getStatus(item) {
        let checkChuaVaoSo =
          item.status == constants.INCOMING_DOC_STATUS.TAO_MOI
            ? "Chưa vào sổ"
            : "";
        let checkStatus =
          item.status == constants.INCOMING_DOC_STATUS.TU_CHOI ? "Từ chối" : "";
        return `${checkChuaVaoSo} ${checkStatus}`;
      },

      closeDialog() {
        this.isOpenDialogCreate = false;
      },

      isShowPriority(id) {
        return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) != -1;
      },

      createDocSuccess() {
        this.isOpenDialogCreate = false;
        this.doSearch();
      },

      initQuery() {
        this.sort = this.$route.query.sort || "updateTime";
        this.order = this.$route.query.order || "desc";
        this.advanceSearchForm = {
          chuyenMonOrDang: this.isUserOfDang ? 2 : 1,
          keyword: this.$route.query.keyword || undefined,
          fromDocDate: this.$route.query.fromDocDate
            ? parseInt(this.$route.query.fromDocDate)
            : undefined,
          toDocDate: this.$route.query.toDocDate
            ? parseInt(this.$route.query.toDocDate)
            : undefined,
          toIncomingDate: this.$route.query.toIncomingDate
            ? parseInt(this.$route.query.toIncomingDate)
            : undefined,
          fromIncomingDate: this.$route.query.fromIncomingDate
            ? parseInt(this.$route.query.fromIncomingDate)
            : undefined,
          docCode: this.$route.query.docCode || undefined,
          quote: this.$route.query.quote || undefined,
          fileContent: this.$route.query.fileContent || undefined,
          docTypeId: this.$route.query.docTypeId || undefined,
          bookId: this.$route.query.bookId || undefined,
          publisherId: this.$route.query.publisherId || undefined,
          outsidePublisherName:
            this.$route.query.outsidePublisherName || undefined
        };
        this.keyword = this.advanceSearchForm.keyword;
      },

      buildQuery() {
        return utils.merge(
          {sort: this.sort || "updateTime", order: this.order || "desc"},
          this.advanceSearchForm
        );
      },

      simpleSearch(keyword) {
        this.keyword = this.advanceSearchForm.keyword = keyword;
        // this.advanceSearchForm.docCode = undefined;
        // this.advanceSearchForm.quote = undefined;
        // this.advanceSearchForm.fileContent = undefined;
        // this.advanceSearchForm.docTypeId = undefined;
        // this.advanceSearchForm.publisherId = undefined;
        // this.advanceSearchForm.outsidePublisherName = undefined;
        // this.advanceSearchForm.toDocDate = undefined;
        // this.advanceSearchForm.fromDocDate = undefined;
        // this.advanceSearchForm.toIncomingDate = undefined;
        // this.advanceSearchForm.fromIncomingDate = undefined;
        this.doSearch();
      },

      advanceSearch(event) {
        let advanceSearchForm = event.advanceSearchForm;
        this.sortList=event.sortList;
        this.advanceSearchForm.keyword = undefined;
        this.keyword = null;
        this.advanceSearchForm.docCode = advanceSearchForm.docCode || undefined;
        this.advanceSearchForm.quote = advanceSearchForm.quote || undefined;
        this.advanceSearchForm.fileContent =
          advanceSearchForm.fileContent || undefined;
        this.advanceSearchForm.docTypeId =
          advanceSearchForm.docTypeId || undefined;
        this.advanceSearchForm.publisherId =
          advanceSearchForm.publisherId || undefined;
        this.advanceSearchForm.priorityId =
          advanceSearchForm.priorityId || undefined;
        this.advanceSearchForm.outsidePublisherName =
          advanceSearchForm.outsidePublisherName || undefined;
        this.advanceSearchForm.toIncomingDate =
          advanceSearchForm.toIncomingDate || undefined;
        this.advanceSearchForm.fromIncomingDate =
          advanceSearchForm.fromIncomingDate || undefined;
        this.advanceSearchForm.sortList =
          event.sortList || undefined;
        this.doSearch();
      },

      doSort(sort) {
        this.sort = sort;
        this.order =
          sort === this.sort ? (this.order === "asc" ? "desc" : "asc") : "asc";
        this.doSearch();
      },

      doSearch() {
        this.$router.replace({
          name: this.$router.name,
          params: this.$route.params,
          query: this.buildQuery()
        });
        this.incomingDocs = [];
        this.page = 0;
        this.$nextTick(
          () => {
            this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.reset();
            this.count();
          }
        );
      },

      infiniteHandler($state) {
        console.log('infinite')
        this.list().then(items => {
          this.page += 1;
          items && items.length ? $state.loaded() : $state.complete();
        });

      },

      list() {
        let pageable;
        if(this.sortList&&this.sortList.length>0){

          let sort=[];
          h.each(this.sortList,(item)=>{
            sort.push(item);
          })
          pageable = {
            page: this.page,
            size: this.size,
            sort: sort
          };
        }else {
          pageable = {
            page: this.page,
            size: this.size,
            sort: [this.sort, this.order].join(",")
          };
        }

        return vbIncomingDocInBookViewService
          .findAllForConfigLDV2(this.advanceSearchForm, pageable)
          .then(response => {
            let items = response.data;
            items && this.incomingDocs.push(...items);
            this.incomingDocs = vbUtils.searchAndSort(this.advanceSearchForm.keyword, this.incomingDocs);
            return items;
          });
      },

      count() {
        return vbIncomingDocInBookViewService
          .countAllForConfigLDV2(this.advanceSearchForm)
          .then(res => this.amountOfDoc = res.data)
      },

      viewDetail(item) {
        item.isRead = "seen";
        this.selectedDocId = item.id;
        this.$router.push({
          name: "vbDenDaVaoSoLDDetail",
          params: {id: item.id},
          query: this.$route.query
        });
      },

      getPiorityClass(id) {
        return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) != -1
          ? "lv1"
          : "lv4";
      }
    }
  };
</script>
<style scoped>
  #searchBox {
    position: relative;
    width: 100%;
  }

  .advance-search {
    font-size: 17px;
    color: #005eb1;
    position: absolute;
    right: 5%;
    top: 50%;
    transform: translateY(-50%);
  }

  .icon-very__small {
    height: 14px;
    padding-top: 4px;
  }

  .icon-info {
    background-color: #f0c330;
    border-radius: 50%;
    width: 15px;
    height: 15px;
    margin-top: -1px;
    margin-left: 2px;
  }
  .eIcon{
    border: solid 1px #007aff;
    border-radius: 2px;
    padding: 0px 3px;
    font-size: 11px;
    color: goldenrod;
    margin-left:2px;
  }
</style>



// WEBPACK FOOTER //
// src/views/doc-in/vbDenDaVaoSoLDIndex.vue